<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Service Enquiry</h1>
    <app-navpath class="hidden md:block" />
  </div>

  <ul class="tabs-container" role="tablist" aria-label="Service enquiry sections">
    <li
      role="tab"
      id="service-enquiry-main-tab"
      aria-controls="service-enquiry-main-panel"
      tabindex="0"
      [attr.aria-selected]="selectedTab === 'main'"
      [ngClass]="
        selectedTab === 'main' ? 'tab-item_selected' : 'tab-item'
      "
      (click)="changeTab('main')"
    >
      Main
    </li>
    <li
      role="tab"
      id="service-enquiry-location-tab"
      aria-controls="service-enquiry-location-panel"
      tabindex="0"
      [attr.aria-selected]="selectedTab === 'location'"
      [ngClass]="
        selectedTab === 'location' ? 'tab-item_selected' : 'tab-item'
      "
      (click)="changeTab('location')"
    >
      Location
    </li>
  </ul>

  <section
    id="service-enquiry-main-panel"
    role="tabpanel"
    aria-labelledby="service-enquiry-main-tab"
    class="content-container__tabs"
    [hidden]="selectedTab !== 'main'"
  >
    <h2 class="sub-heading w-full border-b">Search Criteria</h2>
    <app-data-form
      [dataFields]="searchVehicle"
      dataName="searchVehicle"
      (updateFields_child)="onVehicleChange($event)"
      (clickSearch)="handleSearch($event)"
    />
    <p *ngIf="loading" role="status" class="my-4">
      Searching for vehicle...
    </p>
    <p *ngIf="message" role="status" class="my-4 text-red-600">
      {{ message }}
    </p>

    <ng-container *ngIf="vehicleDetail">
      <h2 class="sub-heading mt-6 w-full border-b">
        Accessories on Contract
      </h2>
      <div class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[32rem]"
          [tableHeaders]="accessoriesContractHeaders"
          [tableEntries]="accessoriesContractEntries"
          [pagination]="false"
        />
      </div>
      <h2 class="sub-heading mt-6 w-full border-b">
        Installed Accessories
      </h2>
      <div class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[24rem]"
          [tableHeaders]="installedAccessoriesHeaders"
          [tableEntries]="installedAccessoriesEntries"
          [pagination]="false"
        />
      </div>
      <div
        class="mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row"
      >
        <button
          class="shorter-btn misc-btn"
          [disabled]="saving || loading"
          (click)="update()"
        >
          <fa-icon [icon]="faPencil" class="mr-1" />Update
        </button>
        <button
          class="shorter-btn clear-btn"
          [disabled]="saving"
          (click)="clear()"
        >
          <fa-icon [icon]="faEraser" class="mr-1" />Clear
        </button>
      </div>
    </ng-container>
  </section>

  <section
    id="service-enquiry-location-panel"
    role="tabpanel"
    aria-labelledby="service-enquiry-location-tab"
    class="content-container__tabs"
    [hidden]="selectedTab !== 'location'"
  >
    <ng-container *ngIf="vehicleDetail; else locationNoVehicle">
      <h2 class="sub-heading w-full border-b">Location Details</h2>
      <app-data-form
        [dataFields]="locationFields"
        dataName="locationFields"
        [columns]="2"
      />
      <button
        class="shorter-btn misc-btn mt-3 w-full md:w-auto"
        [disabled]="saving"
        (click)="addLocation()"
      >
        <fa-icon [icon]="faPlus" class="mr-1" />Add Location
      </button>
      <div class="mt-4 w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[40rem]"
          [tableHeaders]="locationListHeaders"
          [tableEntries]="locationListEntries"
          [pagination]="false"
          (remove)="onRemoveEntry($event)"
        />
      </div>
      <div
        class="mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row"
      >
        <button
          class="shorter-btn misc-btn"
          [disabled]="saving || loading"
          (click)="update()"
        >
          <fa-icon [icon]="faPencil" class="mr-1" />Update
        </button>
        <button
          class="shorter-btn clear-btn"
          [disabled]="saving"
          (click)="clear()"
        >
          <fa-icon [icon]="faEraser" class="mr-1" />Clear
        </button>
      </div>
    </ng-container>
    <ng-template #locationNoVehicle>
      <p role="status">
        Search for a vehicle in the Main tab to view its locations.
      </p>
    </ng-template>
  </section>
</section>
